import Vue from 'vue';
import VueGtm from 'vue-gtm';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

let adapter;

const persistentStorage = {
    cookieConsentRequired: false,
    cookieConsentMarketing: false,

    async get(key) {
        if (Capacitor.platform !== 'web') {
            return adapter
                .get({ key })
                .then(result => {
                    return result ? JSON.parse(result.value) : null;
                })
                .catch(() => null);
        } else {
            return adapter.get(key);
        }
    },
    async set(key, value, skipValidation = false) {
        const allow = skipValidation ? false : Vue.$store.state.user.cookieConsentRequired;
        if (allow || skipValidation) {
            if (Capacitor.platform !== 'web') {
                await adapter.set({
                    key,
                    value: JSON.stringify(value),
                });
            } else {
                adapter.set(key, value);
            }
        }
    },
    async remove(key) {
        if (Capacitor.platform !== 'web') {
            return await adapter.remove({ key });
        } else {
            return adapter.remove(key);
        }
    },
    async confirmCookies({consent, marketing}) {
        this.cookieConsentRequired = consent;
        this.cookieConsentMarketing = marketing;

        Promise.all([
            this.set('cookieConsent_required', consent, true),
            this.set('cookieConsent_marketing', marketing, true)
        ]).then(() => {
            Vue.$store.commit('user/setCookieRequired', consent);

            if (marketing == true && marketing != 'false' && marketing != 'null') {
                Vue.use(VueGtm, {
                    id: process.env.VUE_APP_GTM_ID,
                    enabled: true,
                    debug: false,
                    vueRouter: this.router,
                    ignoredViews: [],
                });
            }
        });
    },
    async initCookieConsent() {
       this.get('cookieConsent_required').then(consent => {
            this.get('cookieConsent_marketing').then(marketing => {
                this.confirmCookies({consent,marketing});
            });
        });
    },
};

Vue.prototype.$persistentStorage = persistentStorage;
Vue.$persistentStorage = persistentStorage;

export default {
    install(Vue, { router }) {
        let installDone = false;
        router.beforeEach((...params) => {
            const [, , next] = params;
            if (installDone) {
                next();
            } else {
                installDone = true;
                if (Capacitor.platform !== 'web') {
                    adapter = Preferences;
                    persistentStorage.initCookieConsent().then(()=>{
                        next();
                    });
                } else {
                    import('vue-cookies').then(VueCookies => {
                        Vue.use(VueCookies);
                        Vue.$cookies.config(process.env.VUE_APP_COOKIE_EXPIRE_TIME);
                        adapter = Vue.$cookies;
                        persistentStorage.initCookieConsent().then(()=>{
                            next();
                        });
                    });
                }
            }
        });
    },
};
